const CardReplenishment = () => {
    return (
        <div className="">Пополнение карты</div>
    )
}

export default CardReplenishment;